<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Message Automation'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <form [formGroup]="form">
      <tidy-card>
        <tidy-row class="card-header">
          <tidy-text
            [header]="'Concierge Level'" />
        </tidy-row>
        <tidy-row>
          <tidy-radio-button
            [form]="form"
            formControlName="conciergeLevel"
            [items]="radioButtonConciergeLevel" />
        </tidy-row>
      </tidy-card>

      <tidy-card>
        <tidy-row class="card-header">
          <tidy-text
            [header]="'Smart Number'" />
          <tidy-toggle
            [toggled]="smartNumber"
            (toggleChanged)="smartNumber = !smartNumber" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'<b>Allow pros, guests, or tenants a dedicated line as &quot;Your Ops Number&quot;</b>'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Great for more consistency and easier to share instructions, you can just say &quot;here is my number&quot;. $39/yr add on.'" />
        </tidy-row>
      </tidy-card>
    </form>

    <tidy-button
      [text]="'Save Settings'"
      [action]="boundSubmit"
      [class]="'primary'" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
